
export function parseUrlParameters(): { [name: string]: string } {
    const params: { [name: string]: string; } = { };

    const match = /\?([^#]+)$/.exec(window.location.href);
    if(match) {
        const paramGroups = match[1].split('&');

        for(const paramGroup of paramGroups) {
            const paramParts = paramGroup.split('=');
            if(paramParts.length < 1) {
                continue;
            }

            const paramName = decodeURIComponent(paramParts[0]);
            if(paramParts.length < 2) {
                params[paramName] = null;
                continue;
            }

            params[paramName] = decodeURIComponent(paramParts[1]);
        }
    }

    return params;
}
